export const conversationKeys = {
  all: ['conversations'] as const,
  list: (_search?: string) => [...conversationKeys.all, 'list'] as const,
  member: (conversationId: string) => [...conversationKeys.all, 'member', conversationId] as const,
  attachments: (conversationId: string, contentType?: string, limit?: number) =>
    [...conversationKeys.all, 'attachments', conversationId, contentType, limit] as const,
  search: (query: string) => [...conversationKeys.all, 'search', query] as const,
  permissions: (conversationId: string) => [...conversationKeys.all, 'permissions', conversationId] as const,
  memberOverrides: (conversationId: string, memberId: string) =>
    [...conversationKeys.all, 'overrides', conversationId, memberId] as const
};
